import * as actions from './actions';

export default function(state = null, action) {
  switch (action.type) {

  case actions.SET_DEAL_TYPE:
    return action.dealType;

  default:
    return state;
  }
}
